const initialState = {
  privacyPolicyModal: false,
  termsOfServiceModal: false,
  termsOfServiceMallModal: false,
  unauthorizedEmailCollectionModal: false,
  popUpModal: {display: false, image: ''},
}

const ModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'PRIVACY_POLICY_ON': {
      return {...state, privacyPolicyModal: true}
    }
    case 'PRIVACY_POLICY_OFF': {
      return {...state, privacyPolicyModal: false}
    }
    case 'TERMS_OF_SERVICE_ON': {
      return {...state, termsOfServiceModal: true}
    }
    case 'TERMS_OF_SERVICE_OFF': {
      return {...state, termsOfServiceModal: false}
    }
    case 'TERMS_OF_SERVICE_MALL_ON': {
      return {...state, termsOfServiceMallModal: true}
    }
    case 'TERMS_OF_SERVICE_MALL_OFF': {
      return {...state, termsOfServiceMallModal: false}
    }
    case 'UNAUTHORIZED_EMAIL_COLLECTION_ON': {
      return {...state, unauthorizedEmailCollectionModal: true}
    }
    case 'UNAUTHORIZED_EMAIL_COLLECTION_OFF': {
      return {...state, unauthorizedEmailCollectionModal: false}
    }
    case `POP_UP_MODAL_ON`: {
      return {
        ...state,
        popUpModal: {display: true, image: action.data},
      }
    }
    case `POP_UP_MODAL_OFF`: {
      return {
        ...state,
        popUpModal: {display: false, image: null},
      }
    }
    default: {
      return {
        ...state,
      }
    }
  }
}

export default ModalReducer
